import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { HeaderBigLogoBlockConfig } from '@front-platform/content-builder';
import { headerBigLogoBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';

import {
  IContentBuilderFieldColor,
  IContentBuilderFieldImage,
} from '@core/models/content-builder-fields.model';
import { NavigationHistoryService } from '@core/services/navigation-history/navigation-history.service';
export interface HeaderBigLogoBlockRuntimeConfig {}

export type HeaderBigLogoBlockConfigInput = Partial<
  Omit<HeaderBigLogoBlockConfig, keyof HeaderBigLogoBlockRuntimeConfig> &
    HeaderBigLogoBlockRuntimeConfig
>;
export type HeaderBigLogoBlockResolvedConfig = Omit<
  HeaderBigLogoBlockConfig,
  keyof HeaderBigLogoBlockRuntimeConfig
> &
  Partial<HeaderBigLogoBlockRuntimeConfig>;
export interface HeaderBigLogoBlockContract extends ConfigComponentContract<
  HeaderBigLogoBlockConfigInput,
  HeaderBigLogoBlockResolvedConfig
> {}

@Component({
  selector: 'app-header-big-logo-block',
  templateUrl: './header-big-logo-block.component.html',
  standalone: false,
})
export class HeaderBigLogoBlockComponent implements HeaderBigLogoBlockContract {
  readonly config = input<HeaderBigLogoBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    HeaderBigLogoBlockConfig,
    HeaderBigLogoBlockRuntimeConfig
  >(headerBigLogoBlockResolveConfig, () => ({ config: this.config() }));
  get isStatic(): boolean {
    return this.resolvedConfig()['is_static'] as unknown as boolean;
  }
  get logo(): IContentBuilderFieldImage | undefined {
    return this.resolvedConfig()['logo'] as unknown as IContentBuilderFieldImage | undefined;
  }
  get backgroundColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['background_color'] as unknown as
      IContentBuilderFieldColor | undefined;
  }

  constructor(private readonly navigationHistoryService: NavigationHistoryService) {}

  back(): void {
    this.navigationHistoryService.goBack();
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(HeaderBigLogoBlockComponent, { 'keyAliases': {} });
